import React from 'react';
import { observer } from 'mobx-react';
import { action, observable, makeObservable } from 'mobx';
import { toastService, type Toast as ToastItem } from '@services/toastService';
import { ImgCancel } from './Images/ImgCancel';
import { ImgWarning } from './Images/ImgWarning';
import { ImgDocumentCheck } from './Images/ImgDocumentCheck';
import './Toast.css';

const ICONS: Record<string, React.FC<{ size?: number }>> = {
  error:   ImgCancel,
  warning: ImgWarning,
  success: ImgDocumentCheck,
  info:    ImgCancel,
};

@observer
class ToastEntry extends React.Component<{ toast: ToastItem }> {
  @observable private _leaving = false;

  constructor(props: { toast: ToastItem }) {
    super(props);
    makeObservable(this);
  }

  @action
  private _dismiss = () => {
    this._leaving = true;
    setTimeout(() => toastService.dismiss(this.props.toast.id), 220);
  };

  render() {
    const { toast } = this.props;
    return (
      <div
        className={`toast toast-${toast.type}${this._leaving ? ' toast-leaving' : ''}`}
        role="alert"
        aria-live="assertive"
      >
        <span className="toast-icon" aria-hidden="true">
          {(() => { const Icon = ICONS[toast.type]; return Icon ? <Icon size={16} /> : null; })()}
        </span>
        <div className="toast-body">
          <div className="toast-title">{toast.title}</div>
          {toast.message && <div className="toast-message">{toast.message}</div>}
        </div>
        <button className="toast-close" onClick={this._dismiss} aria-label="Dismiss"><ImgCancel size={14} /></button>
      </div>
    );
  }
}

@observer
export class ToastContainer extends React.Component {
  render() {
    if (toastService.toasts.length === 0) return null;
    return (
      <div className="toast-container" aria-live="polite">
        {toastService.toasts.map(t => (
          <ToastEntry key={t.id} toast={t} />
        ))}
      </div>
    );
  }
}
